import React, { useState, useRef } from "react";
import BundleDefault from "assets/icons/A4.svg";
import {
  HeartOutlined,
  ShareAltOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Button, Rate } from "antd";
import styles from "./Card.module.scss";
import ShareModal from "../BundleCard/BundleShare";
import { useDataStore } from "../../../../store/DataStoreContext";
import {
  favoritePretestService,
  unfavoritePretestService,
} from "../../../../api/pretest";
import { FaHeart } from "react-icons/fa";
import { PretestTestingButton } from "pages/Pretest/PretestDetail/PretestButton";
import useAuth from "../../../../context/auth";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Card = ({ pretest, i, handleClickCard }) => {
  const { fetchPretest } = useDataStore();
  const {
    state: { user },
  } = useAuth();
  const history = useHistory();

  const [visibleHover, setVisibleHover] = useState(false);
  const [displayShareModal, setDisplayShareModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const preventClickRef = useRef(false);

  const onClickLike = async (id) => {
    if (user) {
      setIsLoading(true);
      preventClickRef.current = true;
      if (!pretest.isFavorite) {
        await favoritePretestService({ id: pretest.id });
      } else {
        await unfavoritePretestService({ id: pretest.id });
      }
      fetchPretest();
      setIsLoading(false);
    } else {
      preventClickRef.current = true;
      history.push("/login");
    }
  };

  const toggleShareModal = () => {
    setDisplayShareModal((prev) => !prev);
  };

  const onClickShare = (event) => {
    preventClickRef.current = true;
    event.stopPropagation();
    toggleShareModal();
  };

  const handleCardClick = () => {
    if (preventClickRef.current) {
      preventClickRef.current = false;
      return;
    }
    handleClickCard(pretest.id);
  };

  return (
    <div
      className={styles.bundle_card}
      key={i}
      onClick={() => {
        handleCardClick();
      }}
    >
      <div
        className={styles.bundle_card_banner}
        onMouseEnter={() => setVisibleHover(true)}
        onMouseLeave={() => setVisibleHover(false)}
      >
        <div className={styles.bundle_banner}>
          {pretest.banner ? (
            <img
              src={pretest.banner}
              alt={pretest.name}
              className={styles.bundle_card_banner_img}
            />
          ) : (
            <img
              src={BundleDefault}
              alt="default"
              className={styles.bundle_card_banner_img}
            />
          )}
          {visibleHover && (
            <div className={styles.bundle_card_banner_hover}>
              {isLoading ? (
                <LoadingOutlined />
              ) : pretest.isFavorite ? (
                <FaHeart
                  className={styles.icon}
                  style={{ color: "#ee5294" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickLike(pretest.id);
                  }}
                />
              ) : (
                <HeartOutlined className={styles.icon} onClick={onClickLike} />
              )}

              <ShareAltOutlined
                className={styles.icon}
                onClick={onClickShare}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.detail}>
        <div className={styles.bundle_card_detail}>
          <div className={styles.detail_creator}>
            <div className={styles.publisher}>{pretest.host.name}</div>
            <div className={styles.vertical}> | </div>
            <div className={styles.writer}>{pretest.writer}</div>
          </div>
          <div className={styles.name}>{pretest.name}</div>
          <div className={styles.bundle_card_detail_rating}>
            <Rate
              value={pretest.rating}
              allowHalf
              disabled
              style={{ fontSize: ".75rem", marginLeft: "0.5rem" }}
            />
          </div>
        </div>
        <div className={styles.bundle_card_button}>
          {pretest.canPractice ? (
            <Button
              type="primary"
              className={styles.bundle_card_button_buy}
              onClick={() => {}}
            >
              {pretest.isPurchase ? "เริ่มทำข้อสอบ" : `฿ ${pretest.price.cash}`}
            </Button>
          ) : (
            <Button
              type="primary"
              className={styles.bundle_card_button_buy}
              onClick={() => {}}
            >
              ดูรายละเอียด
            </Button>
          )}
        </div>
        <ShareModal
          displayShareModal={displayShareModal}
          openShareModal={toggleShareModal}
          closeShareModal={toggleShareModal}
          url={pretest.linkPretest}
        />
      </div>
    </div>
  );
};

export default Card;
